export default __webpack_public_path__ + "static/media/title.beb43459.svg";